<template>
  <div class="container">
    <ToastPrime />
    <DialogPrime
      :header="$t('toastProgressSpinner')"
      v-model:visible="showProgressSpinner"
      :style="{ width: '15vw', height: '15vw' }"
    >
      <div class="card">
        <div class="flex flex-column card-container">
          <div class="flex align-items-center justify-content-center h-5rem m-4">
            <ProgressSpinner />
          </div>
        </div>
      </div>
    </DialogPrime>

    <div class="table">
      <div class="flex flex-row-reverse flex-wrap card-container">
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <p v-html="$t('home_p_NEO')" class="m-4 font-italic"> </p>
          </div>
          <!--<div class="field col-fixed md:col-1 m-2" style="width: 150px">
            <div v-if="false">
              <TemplateFileUploaderComponent />
            </div>
          </div>-->
          <div class="field col-fixed md:col-1 m-2" style="width: 120px">
            <ButtonPrime
              :label="$t('newShipBtn')"
              :style="{ width: '120px' }"
              class="p-button header_button"
              @click="newShip()"
            />
          </div>
        </div>
      </div>
    </div>
        <div class="formgrid grid">
          <div class="field col" style="text-align: left;">
            <DropdownPrime id="year" v-model="yearSelected" :options="allYears" placeholder="Select a year"/>
          </div>
          <div class="field col" style="width: 120px; padding-left: 500px;">
            <ButtonPrime
              :label="$t('generateReportBtn')"
              :style="{ height: '50px' }"
              class="p-button header_button"
              @click="reportHandler()"
            />

            <ButtonPrime
              :label="$t('overalCalificationBtn')"
              :style="{ height: '50px' }"
              class="p-button header_button"
              @click="balanceHandler()"
            />
          </div>
        </div>

    <DataTablePrime
        :value="ships"
        v-model:expandedRows="expandedRows"
        dataKey="id"
        responsiveLayout="scroll"
        class="p-datatable-sm"
      >
      <ColumnPrime :expander="true" headerStyle="width: 2rem" />
      <ColumnPrime field="name" :header="$t('name')" sortable></ColumnPrime>
      <ColumnPrime field="shipTypeStr" :header="$t('shipType')" sortable></ColumnPrime>
      <ColumnPrime field="selectedBaseCII" :header="$t('label_CII_NEO')" sortable></ColumnPrime>
      <ColumnPrime field="selectedBaseETS" :header="$t('label_ETS')" sortable></ColumnPrime>
      <ColumnPrime field="selectedBaseFuelEU" :header="$t('label_FuelEU')" sortable></ColumnPrime>
      <ColumnPrime :header="$t('actions')" :style="{ width: '350px' }">
        <template #body="slotProps1">
          <ButtonPrime
            icon="pi pi-pencil"
            class="p-button actionButton"
            v-tooltip.top="$t('tooltipEditShip')"
            @click="editShip(slotProps1.data)"
          />
          <ButtonPrime
            icon="pi pi-trash"
            class="p-button actionButton"
            v-tooltip.top="$t('tooltipDeleteShip')"
            @click="deleteHandler(slotProps1.data)"
          />
          <ButtonPrime
            icon="pi pi-bolt"
            class="p-button actionButton"
            v-tooltip.top="$t('tooltipCalculateCII')"
            @click="calcCII(slotProps1.data)"
          />
          <ButtonPrime
            icon="pi pi-euro"
            class="p-button actionButton"
            v-tooltip.top="$t('tooltipCalculateETS')"
            @click="calcETS(slotProps1.data)"
          />
          <ButtonPrime
            icon="pi pi-sun"
            class="p-button actionButton"
            v-tooltip.top="$t('tooltipCalculateFuelEU')"
            @click="calcFuelEU(slotProps1.data)"
          />
          <ButtonPrime
            icon="pi pi-plus-circle"
            v-tooltip.top="$t('tooltipNewConfig')"
            class="p-button actionButton"
            @click="dialogHandler(slotProps1.data)"
          />
        </template>
      </ColumnPrime>

       <!--<ColumnPrime field="type.name" :header="$t('modType')" sortable></ColumnPrime>-->
      <template #expansion="slotProps">
        <div id="smallTableContainer" class="smallTableContainer">
          <h4>{{ $t("headerMod") }}:</h4>
          <!--<p>{{ slotProps.data.modifications }}</p>-->
          <DataTablePrime
            :value="slotProps.data.modifications"
            responsiveLayout="scroll"
            class="p-datatable-sm inserted-table"
          >
          
            <ColumnPrime field="name" :header="$t('name')" sortable></ColumnPrime>
            <ColumnPrime field="description" :header="$t('description')" sortable></ColumnPrime>
            <ColumnPrime :header="$t('modType')" sortable>
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.type.name  }}
                </div>
              </template>
            </ColumnPrime>
            <ColumnPrime :header="$t('label_CII_NEO')" sortable>
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.actualCII }}
                </div>
              </template>
            </ColumnPrime>
            <ColumnPrime :header="$t('label_ETS')" sortable>
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.actualETS }}
                </div>
              </template>
            </ColumnPrime>
           <ColumnPrime :header="$t('label_FuelEU')" sortable>
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.actualFuelEU}}
                </div>
              </template>
            </ColumnPrime>
            <ColumnPrime :header="$t('actions')" :style="{ width: '300px' }">
              <template #body="slotProps2">
                <ButtonPrime
                  icon="pi pi-pencil"
                  class="p-button actionButton"
                  v-tooltip.top="'Edit Modification'"
                  @click="editModification(slotProps2.data)"
                />
                <ButtonPrime
                  icon="pi pi-trash"
                  class="p-button actionButton"
                  v-tooltip.top="'Delete Modification'"
                  @click="deleteHandler(slotProps2.data)"
                />
                <ButtonPrime
                  icon="pi pi-money-bill"
                  class="p-button actionButton"
                  v-tooltip.top="'Calculate economic part'"
                  @click="calcEconomicPart(slotProps2.data)"
                />
                <ButtonPrime
                  icon="pi pi-star"
                  class="p-button actionButton"
                  v-tooltip.top="'Calculate Eco-efficiecy Index'"
                  @click="calcEcoefficiencyIndex(slotProps2.data)"
                />
              </template>
            </ColumnPrime>
          </DataTablePrime>
        </div>
      </template>
    </DataTablePrime>

    <!--Diálogo que aparece cuando queremos añadir una nueva modificación a un buque-->
    <DialogPrime
      :header="$t('newModHeader')"
      v-model:visible="displayBasic"
      :breakpoints="{ '960px': '50vw', '640px': '50vw' }"
      :style="{ width: '50vw' }"
    >
      <div class="formgrid grid">
        <div class="field col-12 md:col-6">
          <InputTextPrime
            id="modName"
            v-model="modName"
            :placeholder="$t('name')"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div class="field col-12 md:col-6">
          <InputTextPrime
            id="modDescription"
            v-model="modDescription"
            :placeholder="$t('description')"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div class="field col-12 md:col-6"></div>
        <div class="field col-12 md:col-3">
          <ButtonPrime
            :label="$t('cancel')"
            class="p-button actionButton"
            v-tooltip.top="'Cancel create Configuration'"
            @click="cancelNewModification()"
          />
        </div>
        <div class="field col-12 md:col-3">
          <ButtonPrime
            :label="$t('create')"
            class="p-button actionButton"
            v-tooltip.top="'Create Configuration'"
            @click="newModification()"
          />
        </div>
      </div>
    </DialogPrime>

    <!--Diálogo que aparece cuando le damos al botón de borrar un barco, para confirmar si lo queremos borrar o no-->
    <DialogPrime
      v-model:visible="deleteDialog"
      :breakpoints="{ '960px': '25vw', '640px': '25vw' }"
      :style="{ width: '25vw' }"
    >
      <template #header>
        <h3 v-if="deleteShipDisplay == true">{{ $t("deleteShipDisplay") }} {{ itemToDelete.name }}?</h3>
        <h3 v-if="deleteConfigDisplay == true">{{ $t("deleteConfigDisplay") }} {{ itemToDelete.name }}?</h3>
      </template>
      <div class="formgrid grid">
        <!--Estos 2 botones son para el barco base-->
        <ButtonPrime
          v-if="deleteShipDisplay == true"
          :label="$t('cancel')"
          class="p-button actionButton"
          v-tooltip.top="'Cancel'"
          @click="closeHandler()"
        />
        <ButtonPrime
          v-if="deleteShipDisplay == true"
          :label="$t('confirm')"
          class="p-button actionButton"
          v-tooltip.top="'Confirmation'"
          @click="deleteShip(this.itemToDelete)"
        />
        <!--Estos 2 botones son para la modificación del barco-->
        <ButtonPrime
          v-if="deleteConfigDisplay == true"
          :label="$t('cancel')"
          class="p-button actionButton"
          v-tooltip.top="'Cancel'"
          @click="closeHandler()"
        />
        <ButtonPrime
          v-if="deleteConfigDisplay == true"
          :label="$t('confirm')"
          class="p-button actionButton"
          v-tooltip.top="'Confirmation'"
          @click="deleteModification(this.itemToDelete)"
        />
      </div>
    </DialogPrime>

    <!-- Diálogo que aparece cuando le damos al botón de generar un reporte, para elegir los buques que queremos que salgan en este -->
    <DialogPrime
      v-model:visible="reportDialog"
      :breakpoints="{ '960px': '25vw', '640px': '25vw' }"
      :style="{ width: '25vw' }"
    >
      <template #header>
        <h3>{{ $t("reportDisplay") }}</h3>
      </template>
      
      <div v-for="(item, index) in ships" :key="index" style="padding-bottom: 10px;">
        <div class="formgrid grid" style="text-align: center">
          <div class="field col" style="padding-right: 65px">
            <input type="checkbox" v-model="shipsChecked[index]">
            <label :for="index" style="padding-left: 15px">{{ item.name }}</label>
          </div>
        </div>
        <div v-for="(mod, modIndex) in item.modifications" :key="modIndex">
          <div class="formgrid grid" style="text-align: left">
            <div class="field col" style="padding-left: 150px">
              <input 
                type="radio"
                :name="'modifications-' + index"
                :value="modIndex"
                v-model="selectedModifications[index]"
                @click="toggleSelection(index, modIndex)"
              >
              <label :for="modIndex" style="padding-left: 25px">{{ mod.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="formgrid grid" style="padding-top: 10px">
        <ButtonPrime
          :label="$t('cancel')"
          class="p-button actionButton"
          @click="closeHandler()"
        />
        <ButtonPrime
          :label="$t('confirm')"
          class="p-button actionButton"
          @click="generateReport()"
        />
      </div>
    </DialogPrime>

    <!-- Diálogo que aparece cuando le damos al botón de balance, para elegir los buques y la modificación correspondiente que queremos que salgan en este -->
    <DialogPrime
      v-model:visible="balanceDialog"
      :breakpoints="{ '960px': '25vw', '640px': '25vw' }"
      :style="{ width: '25vw' }"
    >
      <template #header>
        <h3>{{ $t("qualificationDisplay") }}</h3>
      </template>
      
      <DropdownPrime id="year" v-model="balanceYearSelected" :options="allYears" placeholder="Select a year"/>

      <div v-for="(item, index) in ships" :key="index" style="padding-bottom: 10px;">
        <div class="formgrid grid" style="text-align: center">
          <div class="field col" style="padding-right: 65px">
            <input type="checkbox" v-model="shipsChecked[index]">
            <label :for="index" style="padding-left: 15px">{{ item.name }}</label>
          </div>
        </div>
        <div v-for="(mod, modIndex) in item.modifications" :key="modIndex">
          <div class="formgrid grid" style="text-align: left">
            <div class="field col" style="padding-left: 150px">
              <input 
                type="radio"
                :name="'modifications-' + index"
                :value="modIndex"
                v-model="selectedModifications[index]"
                @click="toggleSelection(index, modIndex)"
              >
              <label :for="modIndex" style="padding-left: 25px">{{ mod.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="formgrid grid" style="padding-top: 10px">
        <ButtonPrime
          :label="$t('cancel')"
          class="p-button actionButton"
          @click="closeHandler()"
        />
        <ButtonPrime
          :label="$t('confirm')"
          class="p-button actionButton"
          @click="generateBalance()"
        />
      </div>
    </DialogPrime>
    <DialogPrime
      v-model:visible="balanceResultDialog"
      :breakpoints="{ '960px': '25vw', '640px': '25vw' }"
      :style="{ width: '25vw' }"
    >
      <template #header>
        <h3>{{ $t("qualificationResultDisplay") }}</h3>
      </template>
      <div class="output-box">
        <div v-if="this.balanceResult >= 0" class="formgrid grid" style="text-align: center; padding-top: 15px; padding-bottom: 15px; background-color: #66bb6a;">
          <p class="field col">{{ $t('qualificationResultSurplus') }}</p>
        </div>
        <div v-else class="formgrid grid" style="text-align: center; padding-top: 15px; padding-bottom: 15px; background-color: #e36c09;">
          <p class="field col">{{ $t('qualificationResultDeficit') }}</p>
        </div>

        <div class="formgrid grid" style="text-align: center; padding-top: 15px; padding-bottom: 15px">
          <p class="field col">{{ $t('qualificationResultText') }}<br>{{ this.balanceResult.toFixed(2) }} (tCO<sub>2</sub>eq)</p>
        </div>
      </div>
      <div class="formgrid grid" style="padding-top: 10px">
          <ButtonPrime
            :label="$t('goBack')"
            class="p-button actionButton"
            @click="closeResultHandler()"
          />
        </div>
    </DialogPrime>
  </div>
</template>

<script>
import router from "@/router/index";
import ShipService from "@/services/ShipService";
import ParametricTableService from "@/services/ParametricTableService";
import ModificationService from "@/services/Neobuq/ModificationService";
import store from "@/store/index";
import utils from "@/utils/configuration/config.js";
import { ToastSeverity } from "primevue/api";

export default {

  data(){
    return{
        fleet_name: "Flota1", //por ahora, esta variable no se guarda en ningún sitio
        allYears: ["2023","2024","2025","2026","2027","2028","2029","2030","2031","2032","2033","2034","2035","2036","2037","2038",
        "2039", "2040"],
        yearSelected: "2025",
        balanceYearSelected:"2025",
        editingFleetName : false,

        ships: [],
        shipsAux: [],
        shipsChecked: [],
        balanceChecked: [],
        balanceShips: [
          { name: 'Ship 1', modifications: [{ name: 'Mod 1' }, { name: 'Mod 2' }] },
          { name: 'Ship 2', modifications: [{ name: 'Mod A' }, { name: 'Mod B' }] }
        ],
        selectedModifications: [],
        displayBasic : false,
        deleteShipDisplay: false,
        deleteConfigDisplay: false,
        deleteDialog: false,
        reportDialog: false,
        balanceDialog: false,
        balanceResultDialog: false,
        balanceResult: 0,
        itemToDelete: {},
        expandedRows: [],
        showProgressSpinner: false,
        shipSelectedToCreateModificationId: undefined,
        modificationToClone: undefined,
        modName: "",
        modDescription: "",
    }
  },
  computed: {
    languageState() {
      return store.getters.languageState;
    },
  },
  created(){ 
    //console.log("ShipsTable - created");
    this.shipService = ShipService.getInstance();
    this.modificationService = ModificationService.getInstance();
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
    store.commit("SET_LANGUAGE_STATE", store.getters.languageState);
  },
  mounted(){
    this.shipService.getShips(this.shipsAux)
    
    setTimeout(() => { 
        this.getAllShips()  

        //console.log("ShipsTable - mounted");
        //console.log("ShipsTable - mounted", this.ships);

        this.getAllVariables()

        for(let i=0; i<this.ships.length; i++){
          this.getAllModsShip(i)
        }
        
        // console.log("TODOS LOS BARCOS AQUIIIIIII")
        // console.log(this.ships)
        this.initializeCheckedArrays();
    },1000)
  },

  watch:{
    //en principio cambiaríamos el valor a mostrar del CII, ETS y FuelEU según el año
    yearSelected:{
      handler(newVal){
        //console.log("Variable antigua: " + oldVal)

        for(let i=0; i < this.ships.length; i++){

          for(let j=0; j < this.ships[i].baseCII.length; j++){

            //selectedCII
            if(newVal == this.ships[i].baseCII[j].year){
              this.ships[i].selectedBaseCII = this.ships[i].baseCII[j].value + " (" + this.ships[i].baseCII[j].letter + ")"
              break;
            }else{
              this.ships[i].selectedBaseCII = "-"
            }
          }

          for(let j=0; j < this.ships[i].baseETS.length; j++){
            //selectedETS
            if(this.yearSelected == "2023"){
              this.ships[i].selectedBaseETS = "-"
            }
            else if(this.yearSelected == this.ships[i].baseETS[j].year){
              this.ships[i].selectedBaseETS = this.ships[i].baseETS[j].costEUA
              break;
            }else{
              this.ships[i].selectedBaseETS = "-"
            }
          }

          for(let j=0; j < this.ships[i].baseFuelEU.length; j++){
            //selectedFuelEU
            if(this.yearSelected == "2023" || this.yearSelected == "2024"){
              this.ships[i].selectedBaseFuelEU = "-"
            }
            else if(this.yearSelected == this.ships[i].baseFuelEU[j].year){
              this.ships[i].selectedBaseFuelEU = this.ships[i].baseFuelEU[j].fuelEUPenalty
              break;
            }else{
              this.ships[i].selectedBaseFuelEU = "-"
            }
          }

          //Recogemos las modificaciones
          this.getAllModsShip(i)
        }
      },
      deep: true
    }
  },

  methods:{

    editFleetName(){

      if(!this.editingFleetName){
        this.editingFleetName = true
      }else{
        this.editingFleetName = false
      }
    },

    dialogHandler(item) {

      this.shipSelectedToCreateModificationId = item.id;

      //comprobar que hemos hecho el CII, FuelEU y ETS
      // si alguno de estos campos está vacío, no se va a poder añadir modificaciones
      if(item.baseCII.length == 0 || item.baseFuelEU.length == 0 || item.baseETS.length == 0){
        this.showToast(false, "ERROR: No se puede añadir modificaciones hasta no haber añadido el CII, el FuelEU y el ETS.");
      }else{
        this.modificationToClone = null;
        this.modName = "";
        this.modDescription = "";
        this.displayBasic = true;
      }
    },

    deleteHandler(item) {
      Object.prototype.hasOwnProperty.call(item, "modifications")
        ? (this.deleteShipDisplay = true)
        : (this.deleteConfigDisplay = true);
      this.itemToDelete = item;
      this.deleteDialog = true;
    },

    reportHandler(){
      this.reportDialog = true;
    },

    balanceHandler(){
      this.balanceDialog = true;
    },

    resultBalanceHandler(){
      this.balanceResultDialog = true;
    },

    balanceCheckedbox(ship, mod){
      this.balanceChecked[ship] = { ship: ship, mod: mod }
      console.log(this.balanceCheced)
    },

    initializeCheckedArrays() {
      this.shipsChecked = new Array(this.ships.length).fill(false);
      this.selectedModifications = new Array(this.ships.length).fill(null);
      this.ships.forEach((ship, index) => {
        this.selectedModifications[index] = null
      })
      //console.log(this.selectedModifications)
    },

    closeHandler() {
      this.deleteDialog = false;
      this.deleteShipDisplay = false;
      this.deleteConfigDisplay = false;
      this.reportDialog = false;
      this.balanceDialog = false;
      this.shipsChecked = [];
    },

    closeResultHandler() {
      this.balanceResultDialog = false;
    },

    deleteShip(shipItem) {
      //console.log("deleteShip", shipItem);
      this.deleteShipDisplay = false;
      this.deleteDialog = false;

      //this.shipService.modificationService.deleteAllModifications(shipItem.id)
      this.shipService.deleteShip(shipItem.id);

      this.start_spinner();
    },

    getAllShips(){
      this.shipsAux = []
      this.shipService.getShips(this.shipsAux)
      // console.log("THIS.SHIPSAUUUUUUUUUX")
      // console.log(this.shipsAux)
      // console.log("this.shipsAux.length: " + this.shipsAux.length)

      for(let i=0; i< this.shipsAux.length; i++){
        //si este barco es de NEOBUQ (true), lo añadimos
        if(this.shipsAux[i].isNEOBUQ){
          this.ships.push(this.shipsAux[i])
        }
      }
    },

    getAllModsShip(i){
      for(let j=0; j < this.ships[i].modifications.length; j++){

        //actualCII
        for(let k=0; k < this.ships[i].modifications[j].listCII.length; k++){
          
          if(this.yearSelected == this.ships[i].modifications[j].listCII[k].year){
            this.ships[i].modifications[j].actualCII =  this.ships[i].modifications[j].listCII[k].value + " (" +
                                                        this.ships[i].modifications[j].listCII[k].letter + ")"
          }
        }

        //actualFuelEU
        for(let k=0; k < this.ships[i].modifications[j].listFuelEU.length; k++){

          if(this.yearSelected == "2023" || this.yearSelected == "2024"){
            this.ships[i].modifications[j].actualFuelEU = "-"
          }
          else if(this.yearSelected == this.ships[i].modifications[j].listFuelEU[k].year){
            this.ships[i].modifications[j].actualFuelEU = this.ships[i].modifications[j].listFuelEU[k].fuelEUPenalty
          }
        }

        //actualETS
        for(let k=0; k < this.ships[i].modifications[j].listETS.length; k++){

          if(this.yearSelected == "2023"){
            this.ships[i].modifications[j].actualETS = "-"
          }
          else if(this.yearSelected == this.ships[i].modifications[j].listETS[k].year){
            this.ships[i].modifications[j].actualETS =  this.ships[i].modifications[j].listETS[k].costEUA
          }
        }
      } 
    },

    getAllVariables(){
      //ponemos las variables en las columnas
        for(let i=0; i < this.ships.length; i++){

          for(let j=0; j < this.ships[i].baseCII.length; j++){
            //selectedCII
            if(this.yearSelected == this.ships[i].baseCII[j].year){
              this.ships[i].selectedBaseCII = this.ships[i].baseCII[j].value + " (" + this.ships[i].baseCII[j].letter + ")"
            }
          }

          for(let j=0; j < this.ships[i].baseETS.length; j++){
            //selectedETS
            if(this.yearSelected == "2023"){
              this.ships[i].selectedBaseETS = "-"
            }else if(this.yearSelected == this.ships[i].baseETS[j].year){
              this.ships[i].selectedBaseETS = this.ships[i].baseETS[j].costEUA
            }
          }

          for(let j=0; j < this.ships[i].baseFuelEU.length; j++){
            //selectedFuelEU
            if(this.yearSelected == "2023" || this.yearSelected == "2024"){
              this.ships[i].selectedBaseFuelEU = "-"
            }else if(this.yearSelected == this.ships[i].baseFuelEU[j].year){
              this.ships[i].selectedBaseFuelEU = this.ships[i].baseFuelEU[j].fuelEUPenalty
            }
          }

          //hacemos lo mismo con las modificaciones
          for(let j=0; j < this.ships[i].modifications.length; j++){

            //actualCII
            for(let k=0; k < this.ships[i].modifications[j].listCII.length; k++){
              
              if(this.yearSelected == this.ships[i].modifications[j].listCII[k].year){
                this.ships[i].modifications[j].actualCII =  this.ships[i].modifications[j].listCII[k].value + " (" +
                                                            this.ships[i].modifications[j].listCII[k].letter + ")"
              }
            }

            //actualFuelEU
            for(let k=0; k < this.ships[i].modifications[j].listFuelEU.length; k++){

              if(this.yearSelected == "2023" || this.yearSelected == "2024"){
                this.ships[i].modifications[j].actualFuelEU = "-"
              }
              else if(this.yearSelected == this.ships[i].modifications[j].listFuelEU[k].year){
                this.ships[i].modifications[j].actualFuelEU = this.ships[i].modifications[j].listFuelEU[k].fuelEUPenalty
              }
            }

            //actualETS
            for(let k=0; k < this.ships[i].modifications[j].listETS.length; k++){

              if(this.yearSelected == "2023"){
                this.ships[i].modifications[j].actualETS = "-"
              }
              else if(this.yearSelected == this.ships[i].modifications[j].listETS[k].year){
                this.ships[i].modifications[j].actualETS =  this.ships[i].modifications[j].listETS[k].costEUA
              }
            }
          }
        }
    },

    newShip(){
      this.shipService.selectedShip({});
      router.push({ name: "neobuqEditShip", params: { id: "newShip" } });
    },

    generateReport(){
      let error = true

      this.ships.forEach((item, index) => {
        if(this.shipsChecked[index] == true){
          error = false
        }
        if (this.shipsChecked[index] === undefined) {
          this.shipsChecked[index] = false;
        }
      });

      //console.log(this.shipsChecked)

      if(!error){
        localStorage.setItem("shipsChecked", JSON.stringify(this.shipsChecked))
        localStorage.setItem("selectedModifications", JSON.stringify(this.selectedModifications))
        router.push({ name: "reportForm"});
      }else{
        this.showToast(false, "ERROR: Debe seleccionar al menos un barco para generar el reporte")
      }
    },

    generateBalance(){
      let error = true
      let shipCount = 0
      //console.log(this.selectedModifications)

      this.ships.forEach((item, index) => {
        if(this.shipsChecked[index] == true){
          shipCount++
        }
      });
      
      if(shipCount >= 2){
        error = false
      }

      if(!error){
        //console.log(this.selectedModifications)

        for(let i=0; i < this.ships.length; i++){
          if(this.shipsChecked[i]){
            if(this.selectedModifications[i] != null){
              //Cojo el/los valores necesarios para hacer el cálculo
              this.ships[i].modifications[this.selectedModifications[i]].listFuelEU.forEach( (fuelEU) => {
                if(fuelEU.year == this.balanceYearSelected){
                  console.log("barco " + i + " con la modificacion " + this.selectedModifications[i] + " con compliance balance de " + fuelEU.complianceBalance)
                  this.balanceResult += ((fuelEU.complianceBalance) / 1000000)
                }
              })
            }else{
              this.ships[i].baseFuelEU.forEach( (fuelEU) => {
                if(fuelEU.year == this.balanceYearSelected){
                  console.log("barco " + i + " sin modificacion con compliance balance de " + fuelEU.complianceBalance)
                  this.balanceResult += ((fuelEU.complianceBalance) / 1000000)
                }
              })
            }
          }
        }
        console.log("Suma: " + this.balanceResult.toFixed(2))
        this.resultBalanceHandler()

      }else{
        this.showToast(false, "ERROR: Debe seleccionar al menos dos barcos para generar el balance")
      }
    },

    toggleSelection(index, modIndex) {
      // Si el mod ya está seleccionado, deselecciona
      if (this.selectedModifications[index] === modIndex) {
        this.$nextTick(() => {
          this.selectedModifications[index] = null;
        });
      } else {
        // Selecciona el nuevo mod
        this.$nextTick(() => {
          this.selectedModifications[index] = modIndex;
        });
      }
      console.log(this.selectedModifications)
    },

    editShip(item){
      //console.log("Editamos el buque...")
      let ship = {};

      this.ships.forEach((element) => {
        if (element.id == item.id) {
          ship = element;
        }
      });
      //console.log("Este es el buque que vamos a editar", ship);
      this.shipService.selectedShip(ship);
      store.commit("SET_FORM_STATE", true);
      router.push({ name: "neobuqEditShip", params: { id: ship.id } });
    },

    calcCII(item){
      //console.log("Calculamos el CII de este buque...")
      this.shipService.selectedShip(item);
      router.push({ name: "neobuqCarbon", params: { id: item.id } });
    },

    calcFuelEU(item){
      //console.log("Calculamos el FuelEU de este buque...")
      this.shipService.selectedShip(item);
      router.push({ name: "fuelEU", params: { id: item.id } });
    },

    calcETS(item){
      //console.log("Calculamos el coste de ETS de este buque...")
      this.shipService.selectedShip(item);
      router.push({ name: "ETS", params: { id: item.id } });
    },

    //FUNCIONES SOBRE LAS MODIFICACIONES
    newModification(){
      //console.log("Añadimos una nueva modificacion del buque...")

      this.displayBasic = false;

      var errors = "";

      errors = this.shipService.modificationService.createModification(
        this.shipSelectedToCreateModificationId,
        this.modName,
        this.modDescription
      );

      if (errors != "") {
        this.showToast(false, "Error creando configuración: " + errors);
      } else {
        this.showToast(true, "Configuración creada correctamente");
        this.start_spinner();
        for(let i=0; i<this.ships.length; i++){
          this.modificationService.getModificationsForShip(this.ships[i]);
          this.getAllModsShip(i);
        }
      }
    },

    cancelNewModification() {
      this.displayBasic = false;
    },

    editModification(modificationItem){
      //console.log("Editamos la modificación..." , modificationItem);

      const ship = this.findShipForModification(modificationItem);

      this.shipService.modificationService.selectedModification(modificationItem);
      this.shipService.selectedShip(ship);
      store.commit("SET_FORM_STATE", false);
      router.push({ name: "editModification", params: { id: ship.id } });
    },

    deleteModification(item){
      //console.log("Borramos la modificación..." + item)
      this.deleteConfigDisplay = false;
      this.deleteDialog = false;
      const ship = this.findShipForModification(item);
      this.shipService.modificationService.deleteModification(ship.id, item.id);

      this.start_spinner();
    },
    calcEconomicPart(modificationItem){
      //console.log("Calculamos la parte económica de la modificación..." + modificationItem)

      if(modificationItem.listCII.length == 0 || modificationItem.listFuelEU.length == 0 || modificationItem.listETS.length == 0){
        this.showToast(false, "ERROR: No se puede calcular la parte económica sin antes haber calculado los nuevos valores del CII, FuelEU y ETS.");
      }else{
        const ship = this.findShipForModification(modificationItem);

        this.shipService.modificationService.selectedModification(modificationItem);
        this.shipService.selectedShip(ship);
        this.modificationService.selectedModification(modificationItem)
        router.push({ name: "neobuqEconomicPart", params: { id: ship.id } });
      }
    },

    calcEcoefficiencyIndex(modificationItem){
      //console.log("Calculamos los índice de ecoeficiencia de la modificación..." + modificationItem)

      if(Object.keys(modificationItem.economicData).length == 0 ){
        this.showToast(false, "ERROR: No se pueden calcular los índices de ecoeficiencia sin haber calculado la parte económica.");
      }else{
        const ship = this.findShipForModification(modificationItem);

        this.shipService.modificationService.selectedModification(modificationItem);
        this.shipService.selectedShip(ship);
        this.modificationService.selectedModification(modificationItem)
        router.push({ name: "neobuqEcoefficiencyPart", params: { id: ship.id } });
      }
    },

    findShipForModification(modificationItem) {
      let ship = {};
      this.ships.forEach((element) => {
        //console.log(element, modificationItem);
        element.modifications.forEach((modificationElement) => {
          if (modificationElement.id == modificationItem.id) {
            ship = element;
            //console.log("encontrado", ship);
          }
        });
      });
      return ship;
    },

    start_spinner() {
      this.expandedRowsStored = this.expandedRows;
      this.expandedRows = null;
      this.showProgressSpinner = true;

      setTimeout(this.stopSpinner, 1000);
    },
    stopSpinner() {
      this.showProgressSpinner = false;
      this.expandedRows = this.expandedRowsStored;

      this.ships = [];
      this.getAllShips();
    },

    showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },

  }
}

</script>

<style scoped>
.container {
  display: table;
  width: 100%;
}

#smallTableContainer {
  width: 80%;
  padding-left: 100px;
}

.tableContainer {
  display: table-cell;
}

.table {
  padding-bottom: 5%;
}

.inserted-table {
  padding-bottom: 5%;
}

.actionButton {
  margin: 2px !important;
}

.out {
  font-weight: 700;
  color: #ff5252;
}
.in {
  font-weight: 700;
  color: #66bb6a;
}

.table-header-content{
  margin-right: 50%;
}

#fleetLabel {
  background-color: #337AFF;
  color: white;
  padding-top: 25px;
}

.fleet-label {
  border-radius:20px;
  width: 160px;
}

.edit-fleet-button{
  margin: 10px !important;
}

.output-box{
  width: 100%;
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-left: 4%; 
  padding-right: 4%;
}

</style>